module.exports = __webpack_public_path__ + "static/img/fuwudengji.cca9857.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/yunwei/fuwudengji.jpg
// module id = 8aS2
// module chunks = 6